import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import NewSessionOnCampaignChange from './NewSessionOnCampaignChange';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedNewSessionOnCampaignChange = connect(
  mapStateToProps, null,
)(NewSessionOnCampaignChange);

export default withTranslation(['administration'])(ConnectedNewSessionOnCampaignChange as any);
